import React from 'react';
import { Link } from 'react-router-dom';
import FormSignIn from './form/FormSignIn';
import { getLocaleWordContent } from '@/utils/language.util';

export default function SignInPresenter({ onChangeInput, signIn, ...rest }) {
    return (
        <>
            <div className="login_inner">
                <div className="login_logo" style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}> 
                    <img src={require('@/resources/assets/images/logo.png')} alt="logo" style={{marginRight: "30px"}} />
                    <a href="https://megaazwi.com" style={{color:"#fff", fontSize:"15px"}}>https://megaazwi.com</a>
                </div>
                <div className="login_logo" style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}> 
                    <h2 className="tit_log">
                        <Link to="/">{getLocaleWordContent('로그인')}</Link>
                    </h2>
                </div>
                <div className="sp40"></div>
            </div>
            <div className="bg_left">
                <div className="log_box">
                    <FormSignIn {...rest} onChangeInput={onChangeInput} />
                    <div className="sp30"></div>
                    <p className="text-center">
                        <Link to="/signup">
                            {getLocaleWordContent('계정이 없으십니까?')}
                            {getLocaleWordContent('회원가입')}{' '}
                        </Link>
                    </p>
                </div>
            </div>
        </>
    );
}
